import { type ReactNode } from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props<T extends string | undefined> {
    id: T;
    name: ReactNode;
    onSelect: (location: T) => void;
    icon: IconProp;
    previous?: boolean | string;
    presence?: boolean;
}

export function LocationSelect<T extends string | undefined>({
    id,
    name,
    onSelect,
    icon,
    previous,
    presence,
}: Props<T>): ReactNode {
    return (
        <div
            onClick={() => onSelect(id)}
            className={
                "border-2 border-gray-200 dark:border-slate-300 rounded-lg p-4 mb-4 cursor-pointer shadow flex " +
                "items-center transition-all hover:text-slate-600 hover:shadow-xl " +
                "dark:hover:text-slate-300"
            }
            data-testid="outlet-selector"
        >
            <div>
                <FontAwesomeLight icon={icon} className="mr-2 text-xl" />
            </div>
            <div className="grow">
                <div>
                    <p className="my-0">{name}</p>
                </div>
                {typeof previous === "boolean" && previous && (
                    <div className="text-primary text-sm">
                        (Previously Selected)
                    </div>
                )}
                {typeof previous === "string" && (
                    <div className="text-gray-500 dark:text-gray-300 text-sm">
                        {previous}
                    </div>
                )}
            </div>
            <div>
                {presence && (
                    <div className="">
                        <FontAwesomeLight icon="plug" className="ml-2 text-xl" />
                    </div>
                )}
            </div>
        </div>
    );
}
